import script from "./MillionUsers16167Testimonial.vue?vue&type=script&setup=true&lang=ts"
export * from "./MillionUsers16167Testimonial.vue?vue&type=script&setup=true&lang=ts"

import "./MillionUsers16167Testimonial.vue?vue&type=style&index=0&id=6baa08b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6baa08b6"]])

export default __exports__